import { useMedia } from 'react-use';
import { customMedia } from './customMedia';
/**
 * Hook that re-renders when breakpoint conditions changes. It returns
 * boolean value depending on the breakpoint parameter passed in.
 *
 * @param {string} breakpoint - name of the breakpoint to listen to
 *
 * @returns {boolean} whether the breakpoint condition is met or not.
 *
 * @example
 * const isTablet = useBreakpoint({ breakpoint: TABLET })
 */

export default function useBreakpoint(_ref) {
  var breakpoint = _ref.breakpoint;
  var media = customMedia["--".concat(breakpoint)];

  if (!media) {
    throw new Error("Breakpoint ".concat(breakpoint, " is invalid."));
  }

  return useMedia(media);
}